"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Route = require("../../../provider/Route");

var _reactI18next = require("react-i18next");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Form = function Form() {
  var _useContext = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext.routeInternal;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var translateNs = 'pc-matching:CheckOut';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.getInTouch,
      children: t("".concat(translateNs, ".nodatamessage"))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      id: "noMatching",
      className: _styleModule.default.giveYouACall,
      children: t("".concat(translateNs, ".tryitnow"))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: _styleModule.default.button,
      color: "primary",
      variant: "contained",
      round: true,
      flat: true,
      bold: true,
      texttransform: "none",
      onClick: function onClick() {
        return routeInternal('profile');
      },
      children: t("".concat(translateNs, ".changesearch"))
    })]
  });
};

var _default = Form;
exports.default = _default;